export const TYREHUB = 'hwt'
export const BATTERY = 'hte'
